<script lang="ts" setup>
// ENG-20861: app-level overlay backing the in-house `loading` controller (replaces the
// quasar Loading plugin). Mounted once in App.vue; renders whenever loadingState.visible.
import { loadingState } from "../../composables/loadingOverlay";
</script>

<template>
  <Teleport to="body">
    <Transition name="m-loading-fade" appear>
      <div v-if="loadingState.visible" class="m-loading-overlay" :class="loadingState.overlayClass">
        <div class="m-loading-overlay__backdrop" />
        <div class="m-loading-overlay__box">
          <component :is="loadingState.spinner" :size="80" />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style lang="scss">
.m-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-color);

  &__backdrop {
    position: fixed;
    inset: 0;
    z-index: -1;
    opacity: 0.5;
    background-color: #000;
    transition: background-color 0.28s;
  }

  &__box {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: var(--radius-default);
    padding: var(--space-4);
    color: var(--text-on-dark);
    max-width: 450px;
  }
}

.m-loading-fade-enter-active,
.m-loading-fade-leave-active {
  transition: opacity 0.28s;
}
.m-loading-fade-enter-from,
.m-loading-fade-leave-to {
  opacity: 0;
}
</style>
